import axiosPost from "../axiosPost";

export const SFLoteVoucherDel = async (
    params = {},
    credentials
) => {
    const body = {
        service: "SFLoteVoucherDel",
        params: {
            SFLoteVoucherId: params?.SFLoteVoucherId
        },
    };

    const result = await axiosPost(body, credentials);
    return result;
};
